export const LOTTERY_NS = 'lottery';

export const LOTTERY_URL = '/lottery';

export const BONUSES_URL = '/bonuses?tab=active-offers';

// below it the exact number of tickets sold looks unconvincing
export const TICKETS_COUNT_THRESHOLD = 50;

// rows of winner chips per prize before "+N more"
export const WINNERS_CHIPS_ROWS = 2;
export const WINNERS_CHIPS_ROWS_MOBILE = 1;

// the live channel brings the winners; this only covers a missed message
export const DRAWING_POLL_INTERVAL = 30_000;

export const LOTTERY_NEW_UNTIL = '2026-12-01T00:00:00Z';

export const FALLBACK_CURRENCY = 'EUR';

export enum ELotteryPhase {
  COMING_SOON = 'comingSoon',
  STARTED = 'started',
  DRAWING = 'drawing',
  ENDED = 'ended',
}

export enum EPrizeType {
  CASH = 'cash',
  FREE_SPINS = 'freeSpins',
  PHYSICAL = 'physical',
}

// the value colour of a cash or FS prize; a physical one takes the green
export const PRIZE_COLORS: Record<
  Exclude<EPrizeType, EPrizeType.PHYSICAL>,
  string
> = {
  [EPrizeType.CASH]: '#fcd262',
  [EPrizeType.FREE_SPINS]: '#9eb4d2',
};

export enum ESectionId {
  PRIZES = 'lottery-prizes',
  WINNERS = 'lottery-winners',
}
